export default __webpack_public_path__ + "static/media/Sagewrath.8f768424.jpg";